import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
const validationSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  email: Yup.string().email("Invalid email format").required("Email is required"),
  gender: Yup.string().required("Gender is required"),
  phone: Yup.string().matches(/^[0-9]{10}$/, "Phone number must be 10 digits").required("Phone number is required"),
  state: Yup.string().required("Please select your state"),
  course: Yup.string().required("Please select a course"),
  accept_terms: Yup.boolean().oneOf([true], "You must accept the terms & conditions"),
});


const Form = () => {
  const navigate = useNavigate();

 const formik = useFormik({
  initialValues: {
    name: "",
    email: "",
    gender: "",
    phone: "",
    state: "",
    course: "",
    accept_terms: false,
  },
  validationSchema, // Make sure this is properly defined (Yup schema)
  onSubmit: async (values, { setSubmitting, setStatus }) => {
    try {
      const response = await axios.post(
        "https://letsenroll.in/submit-form.php",
        values,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.success) {
        toast.success(response.data.message);

        // Google Ads conversion tracking
        if (typeof window.gtag !== "undefined") {
          window.gtag("event", "conversion", {
            send_to: "AW-16967330933/o7mbCJLam7IaEPXY05o_",
          });
        }

        setTimeout(() => {
          navigate("/thankyou");
        }, 500);
      } else {
        toast.error(response.data.message || "Submission failed.");
        setStatus(response.data.message || "Submission failed.");
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error("Error submitting form. Please try again.");
      setStatus("Error submitting form. Please try again.");
    } finally {
      setSubmitting(false);
    }
  },
});


  return (
    <div className="form-container ">
      <h2 className="section-title">Get Your Brochure</h2>
      <form onSubmit={formik.handleSubmit}>
        <div className="input-group mb-3">
         
          <input type="text" name="name" className="form-control" placeholder="Name" {...formik.getFieldProps("name")} />
        </div>
        {formik.touched.name && formik.errors.name && <p className="text-danger">{formik.errors.name}</p>}

        <div className="row mb-3">
  <div className="col-md-6">
    <input
      type="email"
      name="email"
      className="form-control"
      placeholder="Email"
      {...formik.getFieldProps("email")}
    />
    {formik.touched.email && formik.errors.email && (
      <p className="text-danger">{formik.errors.email}</p>
    )}
  </div>
  <div className="col-md-6">
    <select
      name="gender"
      className="form-control"
      {...formik.getFieldProps("gender")}
    >
      <option value="">Select Gender</option>
      <option value="Male">Male</option>
      <option value="Female">Female</option>
      <option value="Other">Other</option>
    </select>
    {formik.touched.gender && formik.errors.gender && (
      <p className="text-danger">{formik.errors.gender}</p>
    )}
  </div>
</div>


        <div className="input-group mb-3">
         
          <input type="tel" name="phone" className="form-control" placeholder="Phone" {...formik.getFieldProps("phone")} />
        </div>
        {formik.touched.phone && formik.errors.phone && <p className="text-danger">{formik.errors.phone}</p>}

        <div className="input-group mb-3">
         
          <select name="state" className="form-control" {...formik.getFieldProps("state")}>
          <option value="">Select State</option>
            <option value="Andaman and Nicobar Islands">Andaman and Nicobar Islands</option>
            <option value="Andhra Pradesh">Andhra Pradesh</option>
            <option value="Arunachal Pradesh">Arunachal Pradesh</option>
            <option value="Assam">Assam</option>
            <option value="Bihar">Bihar</option>
            <option value="Chandigarh">Chandigarh</option>
            <option value="Chhattisgarh">Chhattisgarh</option>
            <option value="Dadra and Nagar Haveli">Dadra and Nagar Haveli</option>
            <option value="Daman and Diu">Daman and Diu</option>
            <option value="Delhi">Delhi</option>
            <option value="Goa">Goa</option>
            <option value="Gujarat">Gujarat</option>
            <option value="Haryana">Haryana</option>
            <option value="Himachal Pradesh">Himachal Pradesh</option>
            <option value="Jammu and Kashmir">Jammu and Kashmir</option>
            <option value="Jharkhand">Jharkhand</option>
            <option value="Karnataka">Karnataka</option>
            <option value="Kerala">Kerala</option>
            <option value="Lakshadweep">Lakshadweep</option>
            <option value="Madhya Pradesh">Madhya Pradesh</option>
            <option value="Maharashtra">Maharashtra</option>
            <option value="Manipur">Manipur</option>
            <option value="Meghalaya">Meghalaya</option>
            <option value="Mizoram">Mizoram</option>
            <option value="Nagaland">Nagaland</option>
            <option value="Odisha">Odisha</option>
            <option value="Puducherry">Puducherry</option>
            <option value="Punjab">Punjab</option>
            <option value="Rajasthan">Rajasthan</option>
            <option value="Sikkim">Sikkim</option>
            <option value="Tamil Nadu">Tamil Nadu</option>
            <option value="Telangana">Telangana</option>
            <option value="Tripura">Tripura</option>
            <option value="Uttar Pradesh">Uttar Pradesh</option>
            <option value="Uttarakhand">Uttarakhand</option>
            <option value="West Bengal">West Bengal</option>
          </select>
        </div>
        {formik.touched.state && formik.errors.state && <p className="text-danger">{formik.errors.state}</p>}

        <div className="input-group mb-3">
         
          <select name="course" className="form-control" {...formik.getFieldProps("course")}>
            <option value="" selected disabled>Select Course</option>
                    <option value="BA in Digital Media & Mass Communication">
                      BA in Digital Media & Mass Communication
                    </option>
                    <option value="BA in Film & TV">BA in Film & TV</option>
                    <option value="MBA">MBA</option>
                    <option value="BBA">BBA</option>
                    <option value="BBA MBA Integrated">BBA MBA Integrated</option>
                    <option value="Liberal Studies - UG (BA / B.Sc)">
                      Liberal Studies - UG (BA / B.Sc)
                    </option>
                    <option value="B.Com">B.Com</option>
                    <option value="BCA">BCA</option>
                    <option value="B.Sc. (Agriculture)">
                      B.Sc. (Agriculture)
                    </option>
                    <option value="M.Tech">M.Tech</option>
                    <option value="B.Sc. (Forestry)">B.Sc. (Forestry)</option>
                    <option value="B.Tech MBA INTEGRATED">
                      B.Tech MBA INTEGRATED
                    </option>
                    <option value="B.Tech M.Tech INTEGRATED">
                      B.Tech M.Tech INTEGRATED
                    </option>
                    <option value="B.Tech">B.Tech</option>
                    <option value="M.Sc. (Agriculture)">
                      M.Sc. (Agriculture)
                    </option>
                    <option value="MCA">MCA</option>
                    <option value="B.A. MASS COMMUNICATION">
                      B.A. MASS COMMUNICATION
                    </option>
                    <option value="D.Pharma">D.Pharma</option>
                    <option value="Ph.D">Ph.D</option>
                  </select>
       
        </div>
        {formik.touched.course && formik.errors.course && <p className="text-danger">{formik.errors.course}</p>}

        <div className="mb-3 form-check">
          <input type="checkbox" name="accept_terms" className="form-check-input" {...formik.getFieldProps("accept_terms")} />
          <label className="form-check-label">
            I accept <a href="/" className="text-dark">terms & conditions</a>
          </label>
        </div>
        {formik.touched.accept_terms && formik.errors.accept_terms && <p className="text-danger">{formik.errors.accept_terms}</p>}

        <button type="submit" className="btn btn-dark text-white w-100" disabled={formik.isSubmitting}>
          {formik.isSubmitting ? "Submitting..." : "Submit"}
        </button>
      </form>
    </div>
  );
};

export default Form;
